import { useState } from 'react';
import { useAuth } from '../lib/auth';
import EnvelopeList from './EnvelopeList';
import EnvelopeDetail from './EnvelopeDetail';

export default function Dashboard() {
  const { user, signOut } = useAuth();
  const [openId, setOpenId] = useState<string | null>(null);

  return (
    <main className="wrap">
      <div className="row">
        <h1 style={{ margin: 0 }}>BeckerSign</h1>
        <div className="row" style={{ gap: '.5rem' }}>
          <span className="muted" style={{ fontSize: '.85rem' }}>{user?.email}</span>
          <button onClick={() => void signOut('You signed out.')}>Sign out</button>
        </div>
      </div>
      <p className="muted">Milestone 2 — documents and the audit spine.</p>

      {openId
        ? <EnvelopeDetail envelopeId={openId} onBack={() => setOpenId(null)} />
        : <EnvelopeList onOpen={setOpenId} />}
    </main>
  );
}
